<div class="modal-header">
    <h3 class="modal-title" translate="PROJECTS.NEW_TASK"></h3>
    <button type="button" class="btn-back" (click)="closeRef()">
        <span class="fa fa-arrow-left"></span>
    </button>
</div>
<div class="modal-body">
    <select #stageSelect class="form-control form-control-lg form-layout custom-select">
        <option [value]="'none'">
            None
        </option>
        <option *ngFor="let stage of projectData.stage"
                [value]="stage.position">
            {{stage.name}}
        </option>
    </select>

    <p *ngIf="stageSelect.value !== 'none'">
        {{projectData.stage[stageSelect.value - 1].color}}
    </p>
</div>
